import { ExperimentStates } from "@ane/exp-data/lib/models";
import { schema, normalize } from "normalizr";
import * as _ from "lodash";
import { TrafficFilterUtilInstance } from "@ane/exp-data/lib/utils/TrafficFilterUtils";
const nomalizeProgressionResult = (result) => {
  const progressionStage = new schema.Entity("progressionStage", {}, { idAttribute: "Id" });
  const progression = new schema.Entity(
    "progression",
    {
      Studies: [progressionStage]
    },
    { idAttribute: "Id" }
  );
  const normalizedData = normalize(result, [progression]);
  return {
    resultProgressionIds: normalizedData.result,
    progressions: normalizedData.entities.progression,
    progressionStages: normalizedData.entities.progressionStage
  };
};
const normalizeSingleProgressionResult = (result) => {
  var _a;
  const progressionStage = new schema.Entity("progressionStage", {}, { idAttribute: "Id" });
  const progression = new schema.Entity(
    "progression",
    {
      Studies: [progressionStage]
    },
    { idAttribute: "Id" }
  );
  const normalizeData = normalize(result, progression);
  return {
    resultProgressionId: normalizeData.result,
    progressions: (_a = normalizeData == null ? void 0 : normalizeData.entities) == null ? void 0 : _a.progression,
    progressionStages: normalizeData.entities.progressionStage
  };
};
const IsAnyTrafficFilterChangesInFormForProgression = (selectedProgressionStages, selectedTrafficFilter) => {
  if (!(selectedProgressionStages == null ? void 0 : selectedProgressionStages.length) || !selectedTrafficFilter) {
    return false;
  }
  return _.some(selectedProgressionStages, (stage) => {
    if (!stage.initialTrafficFilters) {
      return true;
    }
    let updatedTrafficFilter = TrafficFilterUtilInstance.populateFiltersWithSelections(
      stage.initialTrafficFilters,
      selectedTrafficFilter
    );
    return TrafficFilterUtilInstance.isTrafficFilterValuesChanged(updatedTrafficFilter, stage.initialTrafficFilters);
  });
};
const isFlightUsedInOnlyNewStage = (progressionCloneGroups, flightName) => {
  const progressions = _.flatten(Object.values(progressionCloneGroups));
  const progressionStages = _.flatten(progressions.map((p) => p.filteredProgressionStages));
  const progressionStagesWhereFlightIsUsed = _.filter(
    progressionStages,
    (ps) => _.flatten(ps.stages.map((stage) => _.keys(stage.flightTrafficMap))).includes(flightName)
  );
  const states = progressionStagesWhereFlightIsUsed.map((s) => s.state.State);
  return _.every(states, (state) => state === ExperimentStates.NEW);
};
export {
  IsAnyTrafficFilterChangesInFormForProgression,
  isFlightUsedInOnlyNewStage,
  nomalizeProgressionResult,
  normalizeSingleProgressionResult
};
//# sourceMappingURL=Progression.utils.js.map
